export const LogoMark = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#12141C" />
    <rect x="0.75" y="0.75" width="62.5" height="62.5" rx="13.25" stroke="rgba(230,194,128,0.35)" strokeWidth="1.5" fill="none" />
    <circle cx="32" cy="35" r="15" stroke="#E6C280" strokeWidth="4.5" />
    <circle cx="32" cy="35" r="5" fill="#38BDF8" />
    <path d="M32 7c3 4.2 4.5 6.7 4.5 8.6a4.5 4.5 0 1 1-9 0C27.5 13.7 29 11.2 32 7z" fill="#E6C280" />
  </svg>
);

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark />
      {!compact && (
        <span className="leading-none">
          <span className="font-display font-extrabold text-lg tracking-wide text-white block">
            OGO
          </span>
          <span className="font-mono text-[9px] uppercase tracking-[0.28em] text-gold block mt-1">
            Hygiene Solutions
          </span>
        </span>
      )}
    </span>
  );
}
